<template>
    <b-card no-body class="card-notification-contest">
      <router-link :to="parent + '/sub/' + link">
      <div class="header">
        <img src="" alt="">
        <b-img :src="img" class="" fluid alt="placeholder"></b-img>
      </div>
      <div class="bottom">
        <div class="left">
            <PuSkeleton circle :loading="isLoading" height="40px" width="40px">                
              <div class="icon">
                <font-awesome-icon :icon="['fas', 'trophy-alt']"/>
              </div>
            </PuSkeleton>
        </div>

        <div class="right" :class="{isLoading : isLoading}">
          <h3>
              <PuSkeleton :loading="isLoading" :count="1" width='120px'>                
                {{title}}
              </PuSkeleton>              
          </h3>            
          <p class="desc">
            <PuSkeleton :loading="isLoading" :count="1">
              {{desc}}
            </PuSkeleton>
          </p>
        </div>
      </div>
      </router-link>
    </b-card>
</template>


<script>
import card from '../card/Card'
//
export default {
  name: "CardNotificationContest",
  components:{ 
  },
  mixins: [card],
  props:{
    link:{
      type:String,
      default:'#',
    },
    parent:{
      type:String,
      default:'Parent',
    },
    title:{
      type:String,
      default:'Mon titre',
    },
    desc:{
      type:String,
      default:'Affaire nouvelle DAB',
    },
    img:{
      type:String,
      default:'/img/challenges-img.png',
    }
  },
  data(){
    return {
        isLoading:true,
        content:'',
    }
  },
  methods : {
  },  
  mounted (){
    this.content = this.getBoutique;
    // this.getPourcentBetween(this.resultOne, this.resultTwo);
    // this.getNegatifOrNot(this.number);
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }   
}
</script>